import React from "react"
import {
  Alert,
  Col,
  Row,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import ClipLoader from "react-spinners/ClipLoader"
const BloodSugarLevel = ({
  bloodModalLoading,
  result,
  hasMeasured,
  setHasMeasured,
  lastAte,
  setLastAte,
  glucoseLevel,
  setGlucoseLevel,
  systolic,
  setSystolic,
  diastolic,
  setDiastolic,
  getFieldError,
}) => {
  return (
    <div>
      {bloodModalLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <ClipLoader color={"#727cf5"} loading={bloodModalLoading} size={50} />
        </div>
      ) : result ? (
        <div>
          <ModalBody>
            <Alert color={result.success ? "success" : "danger"}>
              {result.message}
            </Alert>
          </ModalBody>
        </div>
      ) : (
        <div>
          <ModalHeader>Blood Sugar Level</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Have you measured your blood sugar level?</Label>
              <div>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="measured"
                      value="yes"
                      checked={hasMeasured === true}
                      onClick={() => setHasMeasured(true)}
                      className={getFieldError("measured") ? "is-invalid" : ""}
                    />{" "}
                    Yes
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="measured"
                      value="no"
                      checked={hasMeasured === false}
                      onClick={() => setHasMeasured(false)}
                      className={getFieldError("measured") ? "is-invalid" : ""}
                    />{" "}
                    No
                  </Label>
                </FormGroup>
                {getFieldError("measured") && (
                  <Alert color="danger">{getFieldError("measured")}</Alert>
                )}
              </div>
            </FormGroup>
            {hasMeasured && (
              <>
                <FormGroup>
                  <Label>When was the last time you ate?</Label>
                  <Input
                    type="select"
                    value={lastAte}
                    onChange={e => setLastAte(e.target.value)}
                    className={getFieldError("lastAte") ? "is-invalid" : ""}
                  >
                    <option value="">Select...</option>
                    <option value="last 1 hour">Last 1 hour</option>
                    <option value="1-2 hours">1-2 hours</option>
                    <option value="2-3 hours">2-3 hours</option>
                    <option value="3-4 hours">3-4 hours</option>
                    <option value="4-5 hours">4-5 hours</option>
                    <option value="5+ hours">5+ hours</option>
                  </Input>
                  {getFieldError("lastAte") && (
                    <Alert color="danger">{getFieldError("lastAte")}</Alert>
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>Glucose level</Label>
                  <Input
                    type="number"
                    value={glucoseLevel}
                    onChange={e => setGlucoseLevel(e.target.value)}
                    className={
                      getFieldError("glucoseLevel") ? "is-invalid" : ""
                    }
                  />
                  {getFieldError("glucoseLevel") && (
                    <Alert color="danger">
                      {getFieldError("glucoseLevel")}
                    </Alert>
                  )}
                </FormGroup>
              </>
            )}
            <FormGroup>
              <Label>Blood Pressure (optional)</Label>
              <Row>
                <Col>
                  <Input
                    type="number"
                    placeholder="Systolic"
                    value={systolic}
                    onChange={e => setSystolic(e.target.value)}
                    className={getFieldError("systolic") ? "is-invalid" : ""}
                  />
                </Col>
                <Col>
                  <Input
                    type="number"
                    placeholder="Diastolic"
                    value={diastolic}
                    onChange={e => setDiastolic(e.target.value)}
                    className={getFieldError("diastolic") ? "is-invalid" : ""}
                  />
                </Col>
              </Row>
              {getFieldError("bloodPressure") && (
                <Alert color="danger">{getFieldError("bloodPressure")}</Alert>
              )}
              {getFieldError("systolic") && (
                <Alert color="danger">{getFieldError("systolic")}</Alert>
              )}
              {getFieldError("diastolic") && (
                <Alert color="danger">{getFieldError("diastolic")}</Alert>
              )}
            </FormGroup>
          </ModalBody>
        </div>
      )}
    </div>
  )
}

export default BloodSugarLevel
